import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-subscriptions";

@Injectable({
  providedIn: "root",
})
export class AccountSubscriptionsHandlerService {
  constructor(private apiService: ApiService) {}

  accountSubscriptionsGet(masterAccountID: number, accountAppID: number) {
    return this.apiService.get(`${PATH}/${masterAccountID}/${accountAppID}`);
  }
}
